import * as d3 from 'd3';

import { LoggerFactory } from '../../../helpers/Log';
import { RectFormat } from '../../charts/interfaces';
import { LineChartData } from '../../../models/LineChartData';

const logger = LoggerFactory.getLogger('filterLabels');
const height = 15;

function reduceLabels(acc: RectFormat<LineChartData>[], cur: RectFormat<LineChartData>, ratio: number = 1): RectFormat<LineChartData>[] {
    if (!acc) {
        acc = [];
    }
    if (!acc.length) {
        acc.push(cur);
    } else {
        const previous = acc.pop();
        acc.push(previous);
        const { x, y } = cur;
        const previousLength = previous.item.formattedValue === null || previous.item.formattedValue === undefined ? 0 : previous.item.formattedValue.length;
        const prevEnd = previous.x + (previousLength * 6 + 5) * ratio;
        if (x > prevEnd || y + (height + 2) * ratio < previous.y) {
            acc.push(cur);
        }
    }
    return acc;
}

export function filterLabels(data: RectFormat<LineChartData>[], xScale: d3.time.Scale<any, any>, ratio: number = 1): RectFormat<LineChartData>[] {
    let result = [];
    try {
        logger.debug('Filtering labels data.');
        const domain = xScale.domain();
        const visibleData = data.filter((d) => d.item.timeStamp >= domain[0] && d.item.timeStamp <= domain[1]);
        const reduced = visibleData
            .reduce((acc, cur) => {
                return reduceLabels(acc, cur, ratio);
            }, [])
            .filter((d) => !!d.item && d.item.formattedValue !== null && d.item.formattedValue !== undefined && d.item.formattedValue !== '');
        result = reduced;
        logger.debug('Labels filtered.');
    } catch (e) {
        logger.error(e);
    }
    return result;
}
